document.addEventListener("DOMContentLoaded", function(event) {

    let collapseElementList = [].slice.call(document.querySelectorAll('.js-collapse'))

    let collapseList = collapseElementList.map(function(collapseEl) {
        col = new bootstrap.Collapse(collapseEl, { toggle: false })
        collapseEl.addEventListener('hide.bs.collapse', function() {
            let btn = document.getElementById(collapseEl.dataset.link)
            if (btn) {
                btn.innerHTML = '+';
            }
            let parent = collapseEl.closest('.js-collapse-wrapper');
            if (parent) {
                parent.classList.remove('-is-open');
            }
        })
        collapseEl.addEventListener('show.bs.collapse', function() {
            let btn = document.getElementById(collapseEl.dataset.link)
            if (btn) {
                btn.innerHTML = '-';
            }
            let parent = collapseEl.closest('.js-collapse-wrapper');
            if (parent) {
                parent.classList.add('-is-open');
            }
        })
        return col;
    })
    document.addEventListener('click', function(event) {
        let btn = event.target.closest('.js-collapse-link');
        if (btn) {
            event.preventDefault();
            let target = btn.dataset.target;
            let targetElement = document.getElementById(target)
            new bootstrap.Collapse(targetElement)
            return false;
        }
        btn = event.target.closest('.js-open-all');
        if (btn) {
            event.preventDefault();
            collapseList.forEach(i => {
                i.show();
            })
            return false;
        }
        btn = event.target.closest('.js-close-all');
        if (btn) {
            event.preventDefault();
            collapseList.forEach(i => {
                i.hide();
            })
            return false;
        }
    }, false);
});